import { useState } from "react";
import dayjs from "dayjs";
import { Input, Table, Flex, Select } from "antd";
import MenuActions from "../../../../../../../../../../atom/MenuActions";

const TabAdminStaff = ({
  disableEdit,
  handleActionArchive,
  handleActionEdit,
  handleUserNameClick,
  listUsers,
  loading,
}) => {
  const [searchedText, setSearchedText] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");

  const getFilteredUsers = list =>
    typeFilter === "primary"
      ? list.filter(it => it.company?.primaryContact?.email === it.email)
      : list;

  const columns = [
    {
      filteredValue: [searchedText],
      onFilter: (value, record) =>
        String(`${record.firstName} ${record.lastName}`)
          .toLowerCase()
          .includes(value.toLowerCase()),
      render: allValues => (
        <Flex vertical>
          <a
            onClick={() =>
              handleUserNameClick({
                activeEmail: allValues.email,
                activeSection: "admin",
              })
            }
          >
            {allValues.firstName} {allValues.lastName}
          </a>
          <a
            href={`mailto:${allValues.email}`}
            style={{ color: "#4B4747", fontSize: 12 }}
          >
            {allValues.email}
          </a>
        </Flex>
      ),
      sorter: (a, b) => a.email.localeCompare(b.email),
      title: "Name",
    },
    {
      render: allValues =>
        `Enterprise Admin ${
          allValues.company?.primaryContact?.email === allValues.email
            ? " - Primary"
            : ""
        }`,
      title: "Type",
    },
    {
      render: () => "LevelWealth",
      title: "Organization",
    },
    {
      className: "cell-accent",
      align: "right",
      render: allValues =>
        allValues.lastLoginTime
          ? dayjs(allValues.lastLoginTime).format("MM/DD/YY, h:mma")
          : "N/A",
      sorter: (a, b) => dayjs(a.lastLoginTime) - dayjs(b.lastLoginTime),
      title: "Last Login",
    },
    {
      className: "actions-menu-table-cell",
      render: allValues => (
        <MenuActions
          items={[
            {
              disabled: disableEdit,
              key: "edit",
              label: "Edit User",
              onClick: () => handleActionEdit(allValues.email),
            },
            {
              disabled: disableEdit,
              key: "archive",
              label: "Archive User",
              onClick: () => handleActionArchive(allValues.email),
            },
          ]}
        />
      ),
      width: 40,
    },
  ];

  const options = [
    {
      label: "Admin",
      value: "all",
    },
    {
      label: "Primary Enterprise Admin",
      value: "primary",
    },
  ];

  return (
    <Flex gap={24} vertical>
      <Flex gap={32}>
        <Input
          style={{
            maxWidth: 200,
            height: 37,
            borderRadius: 25,
          }}
          placeholder="Search..."
          onChange={event => setSearchedText(event.target.value)}
        />

        <Flex align="center" gap={8}>
          Show
          <Select
            onChange={setTypeFilter}
            options={options}
            style={{ width: 212 }}
            value={typeFilter}
          />
        </Flex>
      </Flex>

      <Table
        columns={columns}
        dataSource={getFilteredUsers(
          listUsers?.map(it => ({
            ...it,
            key: it.email,
          }))
        )}
        loading={loading}
        pagination={false}
        rowHoverable={false}
        size="small"
      />
    </Flex>
  );
};

export default TabAdminStaff;
